var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.314941,
    width: 77,
    height: 77,
    rx: 38.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1520_6048)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0649 17.9375H33.0649C31.4771 17.9375 30.1899 19.2527 30.1899 20.875V56.125C30.1899 57.7473 31.4771 59.0625 33.0649 59.0625H56.0649C57.6528 59.0625 58.9399 57.7473 58.9399 56.125V20.875C58.9399 19.2527 57.6528 17.9375 56.0649 17.9375Z",
    fill: "#1066B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0649 17.9375H33.0649C31.4771 17.9375 30.1899 19.2527 30.1899 20.875V56.125C30.1899 57.7473 31.4771 59.0625 33.0649 59.0625H56.0649C57.6528 59.0625 58.9399 57.7473 58.9399 56.125V20.875C58.9399 19.2527 57.6528 17.9375 56.0649 17.9375Z",
    fill: "url(#paint0_linear_1520_6048)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5649 22.3438H30.1899V37.0312H44.5649V22.3438Z",
    fill: "#32A9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5649 37.0312H30.1899V51.7188H44.5649V37.0312Z",
    fill: "#167EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9399 37.0312H44.5649V51.7188H58.9399V37.0312Z",
    fill: "#32A9E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9399 22.3438H44.5649V37.0312H58.9399V22.3438Z",
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1520_6048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 35,
    width: 35,
    height: 25
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3149 35.5625H58.9399C60.5278 35.5625 61.8149 36.8776 61.8149 38.5V56.125C61.8149 57.7474 60.5278 59.0625 58.9399 59.0625H30.1899C28.6021 59.0625 27.3149 57.7474 27.3149 56.125V35.5625Z",
    fill: "url(#paint1_linear_1520_6048)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1520_6048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8149 35.5625V41.4375H58.9399V35.5625H61.8149Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8149 59.0625V38.5L25.8774 59.0625H61.8149Z",
    fill: "url(#paint2_linear_1520_6048)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3149 59.0625V38.5L63.2524 59.0625H27.3149Z",
    fill: "url(#paint3_linear_1520_6048)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3149 32.625C27.3149 30.1914 29.2457 28.2188 31.6274 28.2188H40.2524C42.6342 28.2188 44.5649 30.1914 44.5649 32.625V50.25C44.5649 52.6836 42.6342 54.6562 40.2524 54.6562H27.3149V32.625Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8149 25.2812H18.6899C17.1021 25.2812 15.8149 26.5964 15.8149 28.2188V48.7812C15.8149 50.4036 17.1021 51.7188 18.6899 51.7188H38.8149C40.4028 51.7188 41.6899 50.4036 41.6899 48.7812V28.2188C41.6899 26.5964 40.4028 25.2812 38.8149 25.2812Z",
    fill: "url(#paint4_linear_1520_6048)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9399 38.6018V38.3575C35.9399 34.1264 32.9603 31.1562 28.7752 31.1562C24.5673 31.1562 21.5649 34.1466 21.5649 38.3982V38.6425C21.5649 42.8736 24.5446 45.8438 28.7524 45.8438C32.9376 45.8438 35.9399 42.8534 35.9399 38.6018ZM32.5509 38.6425C32.5509 41.4497 31.0043 43.1382 28.7752 43.1382C26.5462 43.1382 24.9767 41.409 24.9767 38.6018V38.3575C24.9767 35.5503 26.5234 33.8618 28.7524 33.8618C30.9587 33.8618 32.5509 35.591 32.5509 38.3982V38.6425Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1520_6048",
    x1: 30.1899,
    y1: 38.5,
    x2: 58.9399,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1520_6048",
    x1: 27.3149,
    y1: 54.3173,
    x2: 61.8149,
    y2: 54.3173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1520_6048",
    x1: 61.8149,
    y1: 48.7813,
    x2: 27.3149,
    y2: 48.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1520_6048",
    x1: 27.3149,
    y1: 48.7813,
    x2: 61.8149,
    y2: 48.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1520_6048",
    x1: 15.8149,
    y1: 38.5,
    x2: 41.6899,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1520_6048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 47,
    fill: "white",
    transform: "translate(15.8149 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookCircle);
export default __webpack_public_path__ + "static/media/outlookCircle.22371db81c667d32388f04aa7ae5aca1.svg";
export { ForwardRef as ReactComponent };